import { render, staticRenderFns } from "./SpamMessage.vue?vue&type=template&id=730bd77f&"
import script from "./SpamMessage.vue?vue&type=script&lang=js&"
export * from "./SpamMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports